import { create } from "zustand";
import type { DeckId } from "./decks";
import type { TarotCard } from "@/entities/tarot-card/model/types";

type DeckStore = {
  deckId: DeckId;
  selectDeckId: (id: DeckId) => void;
  selectedDeckCards: TarotCard[];
  setSelectedDeckCards: (cards: TarotCard[]) => void;
};

const useDeckStore = create<DeckStore>()((set) => ({
  deckId: "rws",
  selectDeckId: (id) => set(() => ({ deckId: id })),
  selectedDeckCards: [],
  setSelectedDeckCards: (cards) => set(() => ({ selectedDeckCards: cards })),
}));

export default useDeckStore;
